import {combineLatest, ReplaySubject} from 'rxjs';
import {filter, distinctUntilChanged, map} from 'rxjs/operators';
import {sd} from '@px/da/sd';
import {spotStorage} from '@px/storage/spot';
import {url$} from './url';
import {wsOpened$} from './ws';
import {wwData$} from './worker-data';

export const spot$ = new ReplaySubject<SpotPair>(1);

export const mode$ = spot$.pipe(
  map((o) => o.mode),
  distinctUntilChanged()
);

url$.pipe(filter((url: Url) => url && url.tradeType === 'Spot')).subscribe((url: Url) => spot$.next(url.tradePair as SpotPair));

combineLatest([url$, wsOpened$])
  .pipe(filter(([url]) => url && url.tradeType === 'Spot'))
  .subscribe(([url]) => {
    const {tradeType, tradePair} = url;
    wwData$.next({type: 'state-symbol', tradeType, symbol: tradePair.symbol, mode: tradePair.mode});
  });

spot$.subscribe((spot: SpotPair) => {
  const {symbol} = spot;
  sd.track('change_tradingview', {symbol, market: 'Spot'});
});

spot$.pipe(filter((spot) => spot.mode === 'Spot')).subscribe(({symbol}: SpotPair) => {
  if (symbol !== spotStorage.readSpotStorage().lastSymbol) {
    spotStorage.updateSpotStorage({lastSymbol: symbol});
  }
});
